require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-168-project-boards.json") })
        }
      }, "path---article-168-project-boards");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-168-project-boards!./.cache/json/article-168-project-boards.json
// module id = 516
// module chunks = 231608221292675